import { Injectable } from '@angular/core';
import * as storejs from 'store';
import { LoggerService } from '../logger.service';

@Injectable({
  providedIn: 'root',
})
export class StorageBrowserService {
  public storageType: string;
  public _data: any = {};
  public _userId = 0;
  public _nameSpace = 'sync';
  public _storage: any;
  private store: any;
  constructor(private log: LoggerService) {
    this.store = storejs;
    if (this.store.enabled) {
      this.log.info('store is enabled');
      this.storageType = 'store';
      this._storage = this.store;
    } else {
      this.log.info('store is using memory, store test failed probably private browsing');
      this.storageType = 'memory';
      this._storage = {
        get: (key: string): unknown => {
          return this._data[key];
        },
        set: <T>(key: string, value: T): void => {
          this._data[key] = value;
        },
        clear: (): void => {
          this._data = {};
        },
        getAll(): unknown {
          return this._data;
        },
      };
    }
  }

  public setMemoryStorage(): void {
    this.storageType = 'memory';
    this._storage = {
      get: (key: string): unknown => {
        return this._data[key];
      },
      set: <T>(key: string, value: T): void => {
        this._data[key] = value;
      },
      clear: (): void => {
        this._data = {};
      },
      getAll(): unknown {
        return this._data;
      },
    };
  }

  public getStorageType(): string {
    return this.storageType;
  }

  /**
   * @ngdoc method
   * @name  setUserId
   * @methodOf sync.service:BrowserStorage
   * @description
   * Sets the user id for the browser storage
   * @param {Integer} userid The user's id
   */
  public setUserId(userid: number): void {
    this._userId = userid;
  }

  /**
   * @ngdoc method
   * @name  set
   * @methodOf sync.service:BrowserStorage
   * @description
   * Sets a value in local storage
   * @param {String} key   The key name
   * @param {*} value      Mixed value, array, object, str, int, etc.
   */
  public set(key: string, value: any): unknown {
    return this._storage.set(this.mkKey(key), value);
  }

  /**
   * @ngdoc method
   * @name  get
   * @methodOf sync.service:BrowserStorage
   * @description
   * Gets a value based on the key
   * @param  {String} key The key to retrieve
   * @return {*}     The value, array, obj, str, int, etc.
   */
  public get(key: string): unknown {
    return this._storage.get(this.mkKey(key));
  }

  /**
   * @ngdoc method
   * @name  getAll
   * @methodOf sync.service:BrowserStorage
   * @description
   * Gets all key=>value stored in local storage
   * @return {[type]} [description]
   */
  public getAll(): unknown {
    return this._storage.getAll();
  }

  /**
   * @ngdoc method
   * @name  clear
   * @methodOf sync.service:BrowserStorage
   * @description
   * Clears the local storage.
   */
  public clear(): unknown {
    return this._storage.clear();
  }

  public mkKey(key: string): string {
    return [this._nameSpace, this._userId, key].join('.');
  }
}
